import { render, staticRenderFns } from "./BarbersPop.vue?vue&type=template&id=43ce33b8&"
import script from "./BarbersPop.vue?vue&type=script&lang=js&"
export * from "./BarbersPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports